<template>

  <ModalContainer queryParam="f017" ref="modalContainer" size="lg">

    <b-alert v-if="messageAlert" show :variant="messageAlert.variant" class="p-2 text-center">
      {{ messageAlert.text }}
    </b-alert>

    <b-card>

      <div>

        <h4 class="text-primary text-center mb-1">PROTOCOLO QUIRÚRGICO</h4>

           <div class="mb-1 row p-1" v-if="dataProcesoComputed">
          <div class="col"><b>Procedimiento:</b> {{ dataProcesoComputed.procedimiento }}</div>
          <div class="col"><b>Paciente: </b> {{ dataProcesoComputed.paciente }}</div>
        </div>

        <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-success"
          active-tab-class="font-weight-bold text-success">
          <b-tab title="Diagnosticos/Procedimiento">
            <b-card>
              <b-row>
                <b-col cols="6">

                  <span>Imagen del procedimiento</span>
                  <b-form-file accept=".jpg, .jpeg, .png" v-model="imagenFile" @change="onFileChange($event)" size="sm">

                  </b-form-file>
                </b-col>
                <b-col class="mt-2" cols="6">
                  <b-button  @click="onViewFile" title="Ver imagen cargada anteriormente" class="mx-1" variant="outline-warning" size="sm">
                    <i class="fa-solid fa-magnifying-glass"></i>
                  </b-button>
                  <b-button v-if="urlPorSubir" @click="openModalVer" title="Ver nueva imagen por subir" variant="outline-success" size="sm">
                    <i class="fa-solid fa-arrow-up"></i>
                  </b-button>
                </b-col>
                <b-col cols="12" class="my-1">
                  <span>Diagnostico:</span>
                  <b-row class="d-flex align-items-center">

                    <SearchOpts v-model="searchDiagnostico" :searchService="diagnosticosService.getByQuerySelect"
                      :minChars="3" :placeholder="'Buscar diagnostico...'" class="col-7" />
                    <b-form-group class="col-3">
                      <b-form-radio v-model="selectedTipoDiagnostico" value="pre">Pre-Operatorio</b-form-radio>
                      <b-form-radio v-model="selectedTipoDiagnostico" value="post">Post-Operatorio</b-form-radio>
                    </b-form-group>
                    <b-col cols="2">
                      <b-button variant="warning" @click="agregarDiagnostico" size="sm">
                        <i class="fa-solid fa-plus" />
                      </b-button>
                    </b-col>

                    <b-col v-if="protocolo.diagnosticosList.length" class="mt-1" cols="12">
                      <b-table small :items="protocolo.diagnosticosList" :fields="fields">
                        <template #cell(operatorio)="data">
                          {{ data.item.operatorio === 'post' ? "POSTOPERATORIO" : "PREOPERATORIO" }}
                        </template>
                        <template #cell(acciones)="data">
                          <b-button @click="eliminarRegistro(data.index)" variant="danger" size="sm">
                            <i class="fa-solid fa-trash"></i>
                          </b-button>
                        </template>
                      </b-table>
                    </b-col>
                  </b-row>

                </b-col>

                <b-col class="col-12">
                  <hr />
                  <span>Procedimiento</span>
                  <b-form-radio-group class="my-1" v-model="protocolo.tipoProcedimiento" :options="[
                    { text: 'Electiva', value: 'electiva' },
                    { text: 'Emergencia', value: 'emergencia' },
                    { text: 'Urgencia', value: 'urgencia' }
                  ]"></b-form-radio-group>
                </b-col>

                <b-col class="col-12 my-1"><span>Proyectado:</span> <b-form-textarea
                    v-model="protocolo.proyectado"></b-form-textarea></b-col>
                <b-col class="col-12"><span>Realizado:</span> <b-form-textarea
                    v-model="protocolo.realizado"></b-form-textarea></b-col>
                <hr />
                <b-col class="col-12">
                  <hr />

                  <span>Tipo Anestesia:</span>
                  <b-form-radio-group class="my-1" v-model="protocolo.tipoAnestesia" :options="[
                    { text: 'General', value: 'general' },
                    { text: 'Regional', value: 'regional' },
                    { text: 'Sedacion', value: 'sedacion' },
                    { text: 'Otros', value: 'otros' }

                  ]"></b-form-radio-group>
                  <b-form-input v-if="protocolo.tipoAnestesia === 'otros'" placeholder="Describa otros">

                  </b-form-input>
                </b-col>


              </b-row>
              <b-row class="mt-1">
                <b-col>
                  <span>Transquirúrgico: </span>
                  <b-form-input v-model="protocolo.transquirurgico">

                  </b-form-input>
                </b-col>
              </b-row>
               <b-row class="mt-1">
                <b-col>
                  <span>Biopsia por congelacion (Resultado): </span>
                  <b-form-input v-model="protocolo.biopsiaCongelacion">
                    
                  </b-form-input>
                </b-col>
                <b-col>
                  <span>Histopatologico (Muestra): </span>
                  <b-form-input v-model="protocolo.histopatologico">
                    
                  </b-form-input>
                </b-col>
              </b-row>

            </b-card>
          </b-tab>
          <b-tab title="Tiempos/Complicaciones">
            <b-card>

              <b-row>



                <b-col cols="6">
                  <span>Fecha Operación:</span>
                  <flat-pickr v-model="protocolo.fechaOperacion" placeholder="Seleccione la fecha"
                    class="form-control" />


                </b-col>
                <b-col cols="3">
                  <span>Hora Inicio:</span>
                  <vue-timepicker v-model="protocolo.horaInicio" fixed-dropdown-button format="HH:mm" manual-input>
                    <template v-slot:dropdownButton>
                      <i class="fa-regular fa-clock"></i>
                    </template>

                  </vue-timepicker>

                </b-col>
                <b-col cols="3">
                  <span>Hora Terminación:</span>
                  <vue-timepicker v-model="protocolo.horaTerminacion" fixed-dropdown-button format="HH:mm" manual-input>
                    <template v-slot:dropdownButton>
                      <i class="fa-regular fa-clock"></i>
                    </template>

                  </vue-timepicker>

                </b-col>
                <hr />

                <b-col class="col-6 my-1">
                  <span>Dieresis</span>
                  <b-form-textarea v-model="protocolo.dieresis"></b-form-textarea>
                </b-col>
                <b-col class="col-6 my-1">
                  <span>Exposicion y Explorados</span>
                  <b-form-textarea v-model="protocolo.exposicion"></b-form-textarea>
                </b-col>
                <b-col class="col-6">
                  <span>Hallazgos Quirurgicos</span>
                  <b-form-textarea v-model="protocolo.hallazgos"></b-form-textarea>
                </b-col>
                <b-col class="col-6">
                  <span>Procedimiento Quirurgico</span>
                  <b-form-textarea v-model="protocolo.procedimientoQuirurgico"></b-form-textarea>
                </b-col>

                <hr />

                <b-col class="col-12 my-1">
                  <span>
                    Complicaciones del procedimiento quirurgico
                  </span>
                  <b-form-textarea v-model="protocolo.complicaciones">

                  </b-form-textarea>
                </b-col>
                <b-col cols="4">
                  <span>Perdida Sanguinea Total</span>
                  <b-form-input v-model="protocolo.perdidaSanguineaTotal"></b-form-input>
                </b-col>
                <b-col cols="4">
                  <span>Sangrado aproximado</span>
                  <b-form-input v-model="protocolo.sangradoAproximado"></b-form-input>
                </b-col>
                <b-col cols="4">
                  <span>Uso de material protésico</span>
                  <b-form-radio-group class="my-1" v-model="protocolo.materialProtesico" :options="[
                    { text: 'Si', value: true },
                    { text: 'No', value: false },


                  ]"></b-form-radio-group>

                </b-col>
                <b-col class="12">
                  <b-form-input class="col-12" v-model="protocolo.dataMaterialProtesico"  v-if="protocolo.materialProtesico"
                    placeholder="Describa material protesico">

                  </b-form-input>
                </b-col>


              </b-row>

            </b-card>
          </b-tab>

          <b-tab title="Integrantes/Responsables">
            <b-card>
              <span>Integrantes del equipo quirurgico:</span>
              <b-row class="mt-1">
                <b-col class="col-4">
                  <span>Tipo Integrante:</span>
                  <v-select placeholder="Seleccione" :options="optionsTipoIntegrante" :reduce="option => option"
                    label="text" v-model="selectedTipoIntegrante" />
                </b-col>
                <b-col class="col-6">
                  <span>Profesional:</span>
                  <SearchOpts v-model="selectedProfesional" :searchService="personasService.searchByQuery"
                    :placeholder="'Buscar persona por nombre'" />
                </b-col>
                <b-col class="col-2 mt-2">
                  <b-button title="Agregar profesional" @click="agregarProfesional" variant="success" size="sm">
                    <i class="fa-solid fa-plus"></i>
                  </b-button>
                </b-col>

                <b-col v-if="protocolo.integrantesList" class="mt-1" cols="12">

                  <b-table v-if="protocolo.integrantesList.length" small :items="protocolo.integrantesList"
                    :fields="fieldsIntegrantes">
                    <template #cell(tipo)="data">
                      <label>{{ data.item.tipo.text.toUpperCase() }}</label>
                    </template>
                    <template #cell(profesional)="data">
                      <label>{{ data.item.profesional.nombres }}</label>
                    </template>

                    <template #cell(acciones)="data">
                      <b-button @click="eliminarRegistroIntegrantes(data.index)" variant="danger" size="sm">
                        <i class="fa-solid fa-trash"></i>
                      </b-button>
                    </template>
                  </b-table>
                </b-col>


              </b-row>
              <hr />
               <span>Datos del profesional responsable:</span>
             
              <b-row class="mt-1">
        
                <b-col class="col-10">
                  <span>Medico Responsable:</span>
                  <SearchOpts v-model="doctor" :searchService="doctoresService.searchDoctoresByTermSelect"
                    :placeholder="'Buscar medico por nombre'" />
                </b-col>
                <b-col class="col-2 mt-2">
                  <b-button title="Agregar medico" @click="agregarMedico" variant="success" size="sm">
                    <i class="fa-solid fa-plus"></i>
                  </b-button>
                </b-col>

                <b-col v-if="protocolo.medicosList" class="mt-1" cols="12">

                  <b-table v-if="protocolo.medicosList.length" small :items="protocolo.medicosList"
                    :fields="fieldsMedicos">
                 
                    <template #cell(acciones)="data">
                      <b-button @click="eliminarRegistroMedicos(data.index)" variant="danger" size="sm">
                        <i class="fa-solid fa-trash"></i>
                      </b-button>
                    </template>
                  </b-table>
                </b-col>


              </b-row>

            </b-card>
          </b-tab>


        </b-tabs>
      </div>
       <ModalViewFile
      v-if="fileToView"
      :urlFile="fileToView"
      v-model="isModalFileVisible"
    />
      <div class="text-right">
        <b-button variant="primary" class="mr-2" @click="onSaveProtocolo">
          Guardar
        </b-button>

        <b-button>
          Cancelar
        </b-button>

      </div>
    </b-card>
    <b-modal id="modal-ver" size="xl">
      <b-card>
        <iframe :src="urlPorSubir" width="100%" height="500px"> </iframe>
      </b-card>
    </b-modal>

  </ModalContainer>

</template>

<script>
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import { ModalViewFile }         from '@/shared/components';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { SearchOpts, ModalContainer } from "@/shared/components";
import { doctoresService, auxiliarService } from "@/shared/services";
import { diagnosticosService } from "../../../atencionMedica/services";
import { procedimientosFormulariosService } from "../../services";
import { personasService } from '../../../admision/services';
import vSelect from "vue-select";
import { fileService } from '../../../../shared/services';


export default {
  components: {
    flatPickr,
    SearchOpts,
    ModalContainer,
    VueTimepicker,
    vSelect,
    ModalViewFile
  },

  props:{
    dataProceso:{
      default:null,
      required:false
    }
  },

  data() {
    return {

      isModalFileVisible:false,
      selectedProfesional: null,
      selectedDoctor: null,
      dataProcesoLocal: null,
      optionsTipoIntegrante: [
        { value: 'Cirujano1', text: 'Cirujano1' },
        { value: 'Cirujano2', text: 'Cirujano2' },
        { value: 'Instrumentista', text: 'Instrumentista' },
        { value: 'Circulante', text: 'Circulante' },
        { value: 'Anestesiologo', text: 'Anestesiologo' },
        { value: 'Ayudante Anestesia', text: 'Ayudante Anestesia' },
        { value: 'Primer Ayudante', text: 'Primer Ayudante' },
        { value: 'Segundo Ayudante', text: 'Segundo Ayudante' },
        { value: 'Tercer Ayudante', text: 'Tercer Ayudante' },
        { value: 'Otros', text: 'Otros' },

      ],
      personasService,
      selectedTipoIntegrante: null,
    
      idRegistroForm: null,
      selectedTipoDiagnostico: null,
      fileToView:null,
      messageAlert: null,
      imagenFile:null,
      protocolo: {
        urlImagen:null,
        proyectado:null,
        realizado:null,
        tipoAnestesia:null,
        fechaOperacion:null,
        horaInicio:null,
        horaTerminacion:null,
        dieresis:null,
        exposición:null,
        hallazgos:null,
        procedimientoQuirurgico:null,
        consentimiento:null,
        complicaciones:null,
        perdidaSanguineaTotal:null,
        sangradoAproximado:null,
        materialProtesico:null,
        dataMaterialProtesico:null,

        integrantesList: [],
        horaInicio: null,
        fechaOperacion: null,
        tipoAnestesia: "",
     
        diagnosticosList: [],
      
        medicosList: [],
        transquirurgico:null,
        biopsiaCongelacion:null,
        histopatologico:null
      },
      
    

      searchDiagnostico: null,
      diagnosticosService,
      idProcActual: null,
      doctoresService,
      auxiliarService,
      periodo: null,
      notasEvolucion: null,
      farmacoterapia: null,
      doctor: null,
      auxiliar: null,
      dispositivo: null,
      profesional: null,
      fechaActual: null,
      horaActual: null,

      birthDateConfig: {
        allowInput: true,
        dateFormat: "Y-m-d", // Solo fecha
      },
      procedimiento: [],
      itemsTabla: [],
      fields: [

        {
          key: "operatorio",
          label: "Tipo Operatorio",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        {
          key: "diagnostico",
          label: "Diagnostico",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],

      fieldsIntegrantes: [

        {
          key: "tipo",
          label: "tipo",
          sortable: true,
          thClass: "text-center",
          tdClass: "small-column",
        },

        {
          key: "profesional",
          label: "Nombres Profesional",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },

        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],

      fieldsMedicos: [

        {
          key: "nombres",
          label: "nombres",
          sortable: true,
          thClass: "text-center",
          tdClass: "small-column",
        },

        {
          key: "especialidad",
          label: "especialidad",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
    

        {
          key: "identificacion",
          label: "identificacion",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },


        {
          key: "acciones",
          label: "",
          sortable: true,
          thClass: "text-center small-column",
          tdClass: "small-column",
        },
      ],
      urlPorSubir:'',
    };
  },
  created() {

    this.setDate();
    this.loadData();

    if (this.jsoFormprotocolo) {
      this.protocolo = this.jsoFormprotocolo
    }

  },

  computed: {
    dataProcesoComputed() {
      return this.dataProceso || this.dataProcesoLocal;
    },
  },

  methods: {
    
    openModalVer() {
      
      this.$bvModal.show("modal-ver");
    },

    onFileChange(event) {
      const file = event.target.files[0];

      const validTypes = ['image/jpeg', 'image/png'];
        if (!validTypes.includes(file.type)) {
            this.$swal.fire({
          icon: "error",
          text: "Solo se permiten archivos en formato jpg o png no en este formato => " + file.type,
            });
          this.imagenFile = null;
          event.target.value = null; // Limpia el input
          return;
        }
      if (file) {
          this.urlPorSubir = URL.createObjectURL(file);
        
      }
    },

    onViewFile() { 
      this.fileToView = this.protocolo.urlImagen;
      this.isModalFileVisible = true;
    },

    agregarProfesional() {

      const listaActualIntegrantes = this.protocolo.integrantesList
      if (listaActualIntegrantes.length > 0) {
        listaActualIntegrantes.forEach(item => {
          console.log(this.selectedProfesional.value, item)
          if (this.selectedProfesional.value === item.profesional.idPersona) {

            this.$swal.fire({
              icon: 'info',
              text: 'Profesional ya registrado'
            })
            this.selectedProfesional = null
            this.selectedTipoIntegrante = null
            return
          }
        }
        )
      }
      this.protocolo.integrantesList.push(
        {
          tipo: this.selectedTipoIntegrante, profesional: {
            nombres: `${this.selectedProfesional.primerApellido} ${this.selectedProfesional.primerNombre}`,
            idPersona: this.selectedProfesional.value
          }
        }
      )
      this.selectedProfesional = null
      this.selectedTipoIntegrante = null
    },

    async loadData() {
      this.protocolo = {
        urlImagen:null,
        proyectado:null,
        realizado:null,
        tipoAnestesia:null,
        fechaOperacion:null,
        horaInicio:null,
        horaTerminacion:null,
        dieresis:null,
        exposición:null,
        hallazgos:null,
        procedimientoQuirurgico:null,
        consentimiento:null,
        complicaciones:null,
        perdidaSanguineaTotal:null,
        sangradoAproximado:null,
        materialProtesico:null,
        dataMaterialProtesico:null,

        integrantesList: [],
        horaInicio: null,
        fechaOperacion: null,
        tipoAnestesia: "",
     
        diagnosticosList: [],
      
        medicosList: [],
        transquirurgico:null,
        biopsiaCongelacion:null,
        histopatologico:null
      
      },


      this.idRegistroForm = null;

      this.tokenProceso = this.$route.query.forms
      let tokenFormulario = this.$route.query.f017;

      // Si no viene f017 en la ruta, intenta obtener el último 017 por token del proceso
      if (!tokenFormulario && this.tokenProceso) {
        try {
          const formularios = await procedimientosFormulariosService.getByTokenPrincipal(
            this.tokenProceso,
            "017"
          );
          if (formularios && formularios.length) {
            tokenFormulario = formularios[0].token;
          }
        } catch (err) {
          console.log("error buscando formulario 017 por tokenProceso", err);
        }
      }

      let responseGet = null;
      try {
        responseGet =
          await procedimientosFormulariosService.obtenerFormProcDataByToken(
            tokenFormulario
          );
      } catch (error) {
        console.error("error cargando formulario 017", error);
      }

      console.log("response get", responseGet)



      if (responseGet) {
        this.messageAlert = {
          variant: "success",
          text: "Se encontró información registrada, se procederá a actualizar"
        }

      } else {
        this.messageAlert = {
          variant: "warning",
          text: "No se encontró informacion registrada"
        }
        return;
      }

      const pacientePersona =
        responseGet?.procedimientoCita?.consultamedica?.cita?.paciente
          ?.persona;

      const paciente = pacientePersona
        ? `${pacientePersona.identificacion}-${pacientePersona.primerApellido} ${pacientePersona.primerNombre}`
        : "";

      const dataProceso = {
        paciente: paciente,
        procedimiento:
          responseGet?.procedimientoCita?.procedimiento?.descripcion || "",
        codigo: responseGet?.procedimientoCita?.procedimiento?.codigo || "",
        descripcion:
          responseGet?.procedimientoCita?.procedimiento?.descripcion || "",
      };

      this.dataProcesoLocal = dataProceso;

      try {
        const protocolo = JSON.parse(responseGet.dataJson)
        this.protocolo = protocolo
      } catch (error) { console.log("error", error) }


 
      this.idRegistroForm = responseGet.id;

    },

    setDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // Meses van de 0 a 11
      const day = String(now.getDate()).padStart(2, "0");
      this.fechaActual = `${year}-${month}-${day}`;
      this.horaActual = now.getHours() + ":" + ("0" + now.getMinutes()).slice(-2);
    },


    eliminarRegistro(index) {
      this.protocolo.diagnosticosList.splice(index, 1);


    },
    eliminarRegistroIntegrantes(index) {
      this.protocolo.integrantesList.splice(index, 1);

    },
     eliminarRegistroMedicos(index) {
      this.protocolo.medicosList.splice(index, 1);

    },



    agregarDiagnostico() {
      if (!this.selectedTipoDiagnostico) {
        this.$swal.fire({
          icon: "info",
          text: "Escoja el tipo de operatorio",
        });
        return;
      }

      const dataTable = this.protocolo.diagnosticosList;

      if (dataTable && dataTable.length > 5) {
        this.$swal.fire({
          icon: "info",
          text: "No puede agregar mas de 6 diagnosticos",
        });
        return;
      }

      let pres = []
      let posts = []

      dataTable.forEach((data) => {
        if (data.operatorio === 'pre') {
          pres.push(data)
        }
        if (data.operatorio === 'post') {
          posts.push(data)
        }
      });

      if (this.selectedTipoDiagnostico === 'pre' && pres.length > 2) {
        this.$swal.fire({
          icon: "info",
          text: "No puede agregar mas de 3 diagnosticos pre operatorios",
        });
        this.selectedTipoDiagnostico = null;
        return;
      }
      if (this.selectedTipoDiagnostico === 'post' && posts.length > 2) {
        this.$swal.fire({
          icon: "info",
          text: "No puede agregar mas de 3 diagnosticos post operatorios",
        });
        this.selectedTipoDiagnostico = null;
        return;
      }

      this.protocolo.diagnosticosList.push({
        diagnostico: this.searchDiagnostico.text,
        diagObject: this.searchDiagnostico,
        operatorio: this.selectedTipoDiagnostico,
      });

      this.searchDiagnostico = null;
      this.selectedTipoDiagnostico = null;
    },



    agregarMedico() {

         if (!this.protocolo.medicosList || this.protocolo.medicosList.length > 0) {
       
        this.$swal.fire({
          icon: "warning",
          text: `Solo se puede agregar 1 responsable`
        })
        return
      }


      if (!this.doctor) {
       
        this.$swal.fire({
          icon: "warning",
          text: `Elija el medico`
        })
        return
      }

      console.log(this.doctor)

      this.protocolo.medicosList.push({
        doctorObject: this.doctor,
        nombres:this.doctor.text,
        especialidad: this.doctor.especialidad,
        identificacion: this.doctor.idPersona.identificacion
      });
      this.doctor = null;
    },


    async onSaveProtocolo() {

       const dataTable = this.protocolo.diagnosticosList;
      console.log("data table", dataTable)
      if (!dataTable || dataTable.length < 1) {
        this.$swal.fire({
          icon: "info",
          text: "Debe agregar un diagnostico al menos"})
        return;
      }

      if (this.imagenFile) {
        try{
           this.protocolo.urlImagen = await fileService.upload('imagenesProcedimiento', this.imagenFile, 'img');
        }catch(error){
          console.log("error", error)
        }
       
      }



      const params = {
        nameForm: "017",
        dataJson: JSON.stringify(this.protocolo),
        tokenProceso: this.tokenProceso,
        idRegistroForm: this.idRegistroForm
      };

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if (!responseSave) {
        this.$swal({
          title: "Error",
          text: "No se guardo! Contacte al equipo de desarrollo",
          icon: "error",
          confirmButtonColor: "#089599",
        });

        return;
      }

      await this.$swal.fire({
        icon: "success",
        text: "Guardado correctamente",
      });

      this.$emit("formulario-guardado");
      
      await this.$router.push({ query: { ...this.$route.query, f017: undefined } });
     

    },
  },

  watch: {


    '$route.query.f017': {
      handler(newValue) {
        if (newValue) { this.loadData() }

      },
    },
  }

};
</script>

<style scoped>
.flatpickr-input {
  font-size: 0.85rem;
  padding: 0.25rem 0.5rem;
}

.parpadeo {
  font-weight: 200;
}
</style>
